import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FabricAirflowLinkedService } from 'shell-models-lib';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricAirflowLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricAirflowLinkedServiceAdapter extends LinkedServiceAdapter<FabricAirflowLinkedService> {
    protected modelConstructor(): new () => FabricAirflowLinkedService {
        return FabricAirflowLinkedService;
    }

    protected model(): IModel {
        return FabricAirflowLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        _linkedService: FabricAirflowLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        _linkedServiceResource: Model.LinkedServiceResource,
        linkedService: FabricAirflowLinkedService
    ): Promise<FabricAirflowLinkedService> {
        return linkedService;
    }
}